<template>
  <!-- Main content -->
 <section class="content">
   <!-- Info boxes -->
   <div class="row">
     <div class="row">
       <div id="row center-block">
          <div class="col-md-12">
            <div class="box">
              <div class="box-header col-md-12">
                <label for="displayName" class="col-sm-2 control-label">
                  <span v-if="flag === 'es'">Nombre de usuario</span>
                  <span v-else-if="flag === 'de'">Benutzername</span>
                  <span v-else-if="flag === 'us'">Username</span>
                  <span v-else>Nome do Usuário</span>
                </label>
                <div class="col-sm-3">
                  <input type="text" class="form-control" id="displayName" v-model="displayNameNew">
                </div>
                <div class="col-sm-3">
                  <button type="buttom" class="btn" v-on:click="alterarNomeUsuario()">
                    <span v-if="flag === 'es'">Registro</span>
                    <span v-else-if="flag === 'de'">Aufnehmen</span>
                    <span v-else-if="flag === 'us'">Save</span>
                    <span v-else>Gravar</span>
                  </button>
                </div>
              </div>
              <div class="box-body col-md-12">
                <div class="col-sm-3">
                  <button type="buttom" class="btn btn-primary" v-on:click="alterarSenhaUsuario()">
                    <span v-if="flag === 'es'">Restablecer contraseña</span>
                    <span v-else-if="flag === 'de'">Passwort zurücksetzen</span>
                    <span v-else-if="flag === 'us'">Redefine password</span>
                    <span v-else>Redefinir Senha</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
      </div>
     </div>
     <!-- /.col -->
     <!-- fix for small devices only -->
     <div class="clearfix visible-sm-block"></div>
   </div>
   <!-- /.row -->

   <!-- /.row -->

   <!-- Main row -->
   <div class="row">
   <!-- /.row -->
 </div>
 </section>
 <!-- /.content -->
</template>
<script>
import {firebaseApp} from '../../helpers/firebaseApp'

export default {
  name: 'usuario',
  mounted() {
    this.buscarUsuario()
  },
  computed: {
    flag () {
      return this.$store.state.flag
    },
    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    }
  },
  data () {
    return {
      displayNameNew: ''
    }
  },
  methods: {
    track () {
      this.$ga.page('/usuario')
    },
    showAlert (titulo, mensagem, tipoMensagem, exibeBotao, textoBotao) {
      // Use sweetalret2
      this.$swal({
        title: titulo,
        icon: mensagem,
        type: tipoMensagem,
        showConfirmButton: exibeBotao,
        confirmButtonText: textoBotao
      })
    },
    buscarUsuario: function() {
      this.displayNameNew = this.$store.state.user.displayName
    },
    alterarNomeUsuario: function() {
      var NomeAlterado = 'NomeAlterado'
      var FavorLogar = 'FavorLogar'
      var NaoAtendida = 'NaoAtendida'
      var FalhaNome = 'FalhaNome'
      var bandeira = this.$store.state.flag
      switch (bandeira) {
        case 'de':
          NomeAlterado = 'Name erfolgreich geändert!'
          FavorLogar = 'Bitte melden Sie sich erneut an, damit die Änderungen angezeigt werden!'
          NaoAtendida = 'Anfrage verpasst!'
          FalhaNome = 'Änderung des Namens fehlgeschlagen!'
          break
        case 'us':
          NomeAlterado = 'Name changed successfully!'
          FavorLogar = 'Please log in again for changes to be displayed!'
          NaoAtendida = 'Request missed!'
          FalhaNome = 'Failed to change name!'
          break
        case 'br':
          NomeAlterado = 'Nombre cambiado con éxito!'
          FavorLogar = '¡Vuelva a iniciar sesión para que se muestren los cambios!'
          NaoAtendida = 'Solicitud perdida!'
          FalhaNome = '¡No se pudo cambiar el nombre!'
          break
        default:
          NomeAlterado = 'Nome alterado com sucesso!'
          FavorLogar = 'Favor logar novamente para as alterações serem exibidas!'
          NaoAtendida = 'Solicitação não atendida!'
          FalhaNome = 'Falha ao alterar o nome!'
          break
      }
      var user = firebaseApp.auth().currentUser
      var confirmar = user.updateProfile({
        displayName: this.displayNameNew
      }).then(function() {
        this.$store.commit('SET_USER', firebaseApp.auth().currentUser)
        window.localStorage.setItem('user', JSON.stringify(firebaseApp.auth().currentUser))
        return true
      }).catch(function(error) {
        console.log(error)
        return false
      })
      if (confirmar) {
        this.showAlert(NomeAlterado, FavorLogar, 'info', true, 'Ok')
      } else {
        this.showAlert(NaoAtendida, FalhaNome, 'warning', true, 'Ok')
      }
    },
    alterarSenhaUsuario: function() {
      var NaoAtendida = 'NaoAtendida'
      var Atendida = 'Atendida'
      var EmailEnviado = 'EmailEnviado'
      var EmailFalha = 'EmailFalha'
      var bandeira = this.$store.state.flag
      switch (bandeira) {
        case 'de':
          NaoAtendida = 'Anfrage verpasst!'
          Atendida = 'Anfrage erfolgreich gestellt!'
          EmailEnviado = 'E-Mail zum Zurücksetzen des Passworts gesendet an '
          EmailFalha = 'Fehler beim Senden der E-Mail zum Zurücksetzen des Kennworts an '
          break
        case 'us':
          NaoAtendida = 'Request missed!'
          Atendida = 'Request made successfully!'
          EmailEnviado = 'Password reset email sent to '
          EmailFalha = 'Failed to send password reset email to '
          break
        case 'es':
          NaoAtendida = 'Solicitud perdida!'
          Atendida = 'Solicitud realizada con éxito!'
          EmailEnviado = 'Correo electrónico de restablecimiento de contraseña enviado a '
          EmailFalha = 'Error al enviar el correo electrónico de restablecimiento de contraseña a '
          break
        default:
          NaoAtendida = 'Solicitação não atendida!'
          Atendida = 'Solicitação efetuada com Sucesso!'
          EmailEnviado = 'Email de redefinição de senha enviado para '
          EmailFalha = 'Falha ao enviar email de redefinição de senha para '
          break
      }
      var auth = firebaseApp.auth()
      var emailAddress = this.$store.state.user.email
      var confirmar = auth.sendPasswordResetEmail(emailAddress).then(function() {
        return true
      }).catch(function(error) {
        console.log(error)
        return false
      })
      if (confirmar) {
        this.showAlert(Atendida, EmailEnviado + emailAddress, 'info', true, 'Ok')
      } else {
        this.showAlert(NaoAtendida, EmailFalha + emailAddress, 'warning', true, 'Ok')
      }
    }
  }
}
</script>

<style>
#notFound {
 padding: 10em;
 color: white;
}
</style>



// WEBPACK FOOTER //
// Usuario.vue?af324096